import * as React from "react"
import styled from "styled-components"
import { timezoneMap, monthMap } from "../../utils/constants"

const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0;
  gap: 48px;
`

const StyledContent = styled.div`
  max-width: 500px;
  display: flex;
  flex-direction: column;
  & a {
    font-size: 18px;
    text-decoration: none;
    color: #6e60f9;
    inline-size: fit-content;
  }
  & p {
    margin: 0 0 40px 0;
  }
  & h2 {
    margin-bottom: 16px;
  }
`

const StyledCalendar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`

const StyledContainer = styled.div`
  display: flex;
  gap: 1rem;
  border: 1px solid #d5d4f9;
  border-radius: 10px;
  padding: 0.5rem;
  width: 360px;
  background: white;
  height: 104px;
`

const StyledDate = styled.div`
  background: rgba(241, 240, 252, 0.35);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  min-width: 2rem;
  border: 1px solid #d5d4f9;
  border-radius: 10px;

  > span {
    &.day {
      font-family: "Menlo", monospace;
      font-size: 2rem;
      font-weight: bold;
      color: #6e60f9;
    }
    &.month {
      font-size: 0.5rem;
    }
  }
`
const StyledTitle = styled.div`
  > span {
    margin: 0 0;
    font-size: 0.8rem;
  }
  > a {
    color: black;
    font-weight: bold;
  }
  display: flex;
  flex-direction: column;
`

const parseDate = date => {
  let dateObj = new Date(date)
  let month = dateObj.getMonth()
  let day = dateObj.getDate()
  let hour = dateObj.getHours()
  let minute = dateObj.getMinutes()
  if (hour < 10) {
    hour = "0" + hour
  }
  if (minute < 10) {
    minute = "0" + minute
  }
  if (day < 10) {
    day = "0" + day
  }
  let time = `${hour}:${minute}`
  return [monthMap[month], day, time]
}

const EventCalendar = ({ data, numberOfEvents, content }) => {
  const upcomingEvents = data.filter(event => {
    return new Date(event.event.start) >= new Date()
  })

  const events = upcomingEvents.slice(0, numberOfEvents)

  return (
    <StyledWrapper>
      <StyledContent>{content}</StyledContent>
      <StyledCalendar>
        {events.length > 0 ? (
          events.map(event => {
            const [month, day, time] = parseDate(event.event.start)
            return (
              <StyledContainer key={event.title}>
                <StyledDate>
                  <span class="month">{month}</span>
                  <span class="day">{day}</span>
                </StyledDate>
                <StyledTitle>
                  <span>
                    {time} {timezoneMap[event.event.timezone]}
                  </span>
                  <a
                    href={`https://www.mongodb.com/community/forums/t/${event.id}`}
                    rel="noopener"
                    target="_blank"
                  >
                    {event.title}
                  </a>
                </StyledTitle>
              </StyledContainer>
            )
          })
        ) : (
          <img
            style={{
              borderRadius: "50px",
              width: "100%",
              height: "100%",
              boxShadow: "0px 7px 13px rgba(6, 22, 33, 0.13)",
            }}
            alt="no future events placeholder"
            src="https://webimages.mongodb.com/_com_assets/cms/kze3vbe452fkoetdx-PC4A7967%201.png?auto=format%252Ccompress"
          />
        )}
      </StyledCalendar>
    </StyledWrapper>
  )
}

export default EventCalendar
